module.exports = __webpack_public_path__ + "static/media/icon-comment.419120e5.svg";